import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_ossCompanySelector = _resolveComponent("ossCompanySelector")!
  const _component_ossAccountingPeriodSelector = _resolveComponent("ossAccountingPeriodSelector")!
  const _component_ossDatePickerFilled = _resolveComponent("ossDatePickerFilled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dialog) = $event)),
    onValid: _ctx.createManualUserActivity,
    validLoading: _ctx.loading,
    validDisabled: _ctx.validDisabled,
    title: 'Suivi des temps'
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        style: _normalizeStyle({ width: _ctx.$vuetify.display.mobile ? 'auto' : '800px' })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "d-flex justify-end pb-5"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_toggle, {
                modelValue: _ctx.windowStep,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.windowStep) = $event)),
                rounded: "xl",
                variant: "outlined",
                density: "compact",
                color: "primary",
                "base-color": "whitesmoke"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, { value: 'form' }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { icon: "$fa-user-edit" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, { value: 'table' }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { icon: "$fa-history" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window, {
                modelValue: _ctx.windowStep,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.windowStep) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window_item, { value: 'form' }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_form, {
                        modelValue: _ctx.valid,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.valid) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, {
                            "no-gutters": "",
                            class: "d-flex justify-center align-center pb-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "d-flex pa-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ossCompanySelector, {
                                    modelValue: _ctx.company,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.company) = $event)),
                                    items: _ctx.allAvailableCompanies,
                                    selectClass: 'oss-dark',
                                    chipMaxLength: 9
                                  }, null, 8, ["modelValue", "items"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "8",
                                class: "pa-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ossAccountingPeriodSelector, {
                                    modelValue: _ctx.accountingPeriod,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.accountingPeriod) = $event)),
                                    global: false,
                                    companyId: _ctx.company.id,
                                    disabled: !_ctx.company.id,
                                    dense: "",
                                    block: "",
                                    selectClass: 'oss-dark'
                                  }, null, 8, ["modelValue", "companyId", "disabled"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "4",
                                class: "d-flex pa-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ossDatePickerFilled, {
                                    modelValue: _ctx.date,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.date) = $event)),
                                    label: 'Date',
                                    textFieldReadOnly: false,
                                    "hide-details": "",
                                    class: "w-100"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "4",
                                class: "pa-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field_filled, {
                                    modelValue: _ctx.duration.hours,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.duration.hours) = $event)),
                                    modelModifiers: { number: true },
                                    label: 'Nombre d\'heures',
                                    density: "compact"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "4",
                                class: "pa-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field_filled, {
                                    modelValue: _ctx.duration.minutes,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.duration.minutes) = $event)),
                                    modelModifiers: { number: true },
                                    label: 'Nombre de minutes',
                                    density: "compact"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "4",
                                class: "pa-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field_filled, {
                                    modelValue: _ctx.sumMinutes,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.sumMinutes) = $event)),
                                    modelModifiers: { number: true },
                                    label: 'Nombre total de minutes',
                                    readonly: "",
                                    rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                    density: "compact"
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (_ctx.windowStep === 'table')
                    ? (_openBlock(), _createBlock(_component_v_window_item, {
                        key: 0,
                        value: 'table'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "d-flex justify-end subtitle-2 pb-2"
                              }, {
                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                  _createTextVNode(" Vos 100 dernières entrées ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_virtual_scroll, {
                                    "item-height": 60,
                                    items: _ctx.manualUserActivities,
                                    height: 
                                        _ctx.manualUserActivities.length > 10
                                            ? '600px'
                                            : _ctx.manualUserActivities.length * 60 + 'px'
                                    ,
                                    class: "py-3",
                                    bench: "2"
                                  }, {
                                    default: _withCtx(({ item }) => [
                                      (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: item.id,
                                        class: "oss-list-item mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "4",
                                                class: "d-flex align-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(item.company.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, {
                                                cols: "3",
                                                class: "d-flex justify-center align-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.formatDate(item.date)), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, {
                                                cols: "3",
                                                class: "d-flex justify-center align-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.formatDuration(item.duration)), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, {
                                                cols: "2",
                                                class: "d-flex justify-center align-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_btn_icon, {
                                                    icon: "$delete ",
                                                    color: "error",
                                                    onClick: ($event: any) => (_ctx.deleteManualUserActivity(item.id)),
                                                    size: "small"
                                                  }, null, 8, ["onClick"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    ]),
                                    _: 1
                                  }, 8, ["items", "height"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }, 8, ["modelValue", "onValid", "validLoading", "validDisabled"]))
}